import type { AppState } from '@store/types'

export const migrationAuthSelector = {
  getUserEmojis: (state: AppState): string[] => state.auth.emojis,
  getUserId: (state: AppState): string => state.auth.id,
}
